import Catalyst from '@Services/Catalyst';

// eslint-disable-next-line import/prefer-default-export
export const trackAdobeAnalyticsError = (formError) => {
  if (formError) {
    Catalyst.trackError(
      {
        message: formError,
        component: 'Advanced Search',
      },
      'fe-'
    );
  }
};
